import { Injectable, inject } from '@angular/core';
import { Globals } from '@smarttask-common/src/lib/services/globals';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { NotificationGroupSQLModel } from '@smarttask-common/src/lib/models/Notification/NotificationGroupSQLModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class OrganizationUserHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.organization_user_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.organization_user_unsubscribe;

    private globals = inject(Globals);

    constructor() {
        super();
        this.init();
    }

    protected override canSubscribe(): boolean {
        return this.globals.auth_data != undefined;
    }

    /** This hub's groups are keyed by (organization_id, user_id). */
    protected override subscribeArgs(organization_id: number): any[] {
        return [organization_id, this.globals.auth_data.user_id];
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.organization_user_notification_new, () => {
            this.broadcast(SharedEventNameEnum.organization_user_notification_new);
        });

        this.on(SharedEventNameEnum.organization_user_notification_all_archive_state, (archive_state: boolean) => {
            this.broadcast(SharedEventNameEnum.organization_user_notification_all_archive_state, { archive_state });
        });

        this.on(
            SharedEventNameEnum.organization_user_notifications_archive_state,
            (notifications: Array<NotificationGroupSQLModel>, archive_state: boolean) => {
                this.broadcast(SharedEventNameEnum.organization_user_notifications_archive_state, { notifications, archive_state });
            },
        );
    };
}
